import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getFormValues } from 'redux-form';
import * as _ from 'lodash';
import moment from 'moment';

import { Filter, Main } from 'Containers';
import * as actions from './state/actions';
import BillingAccountForm from './components/BillingAccountForm';
import { ReportFieldEnum } from 'Common/FieldEnum';
import { createToast, toastType } from 'Common/ToastHelper';
import { ReportGeneration } from 'Common/ObjectHelper';
import { BILLING_ACCOUNT_FORM_NAME } from 'Common/FormEnum';

class BillingAccountContainer extends Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.fetching && nextProps.detailReport) {
      if (nextProps.detailReport.length !== 0) {
        const { detailReport } = nextProps;
        ReportGeneration(detailReport, 'BillingDetailReport');
        this.props.clearDetailReportDataAction();
      }
    }

    if (this.props.fetching && nextProps.listReport) {
      if (nextProps.listReport.length !== 0) {
        const { listReport } = nextProps;
        ReportGeneration(listReport, 'BillingListReport');
        this.props.clearListReportDataAction();
      }
    }
  }

  formSubmit = values => {
    let studentIds = _.filter(this.props.billingList, x => {
      return x.Allowed === 1;
    }).map(x => x.Id);

    if (studentIds.length > 0) {
      if (values[ReportFieldEnum.DetailType] === 'Details') {
        const modal = {
          SiteId: values[ReportFieldEnum.Site],
          studentIds: studentIds,
          DateFrom: values[ReportFieldEnum.FromDate],
          DateTo: values[ReportFieldEnum.ToDate],
        };
        this.props.billingReportDetailAction(modal);
      } else if (values[ReportFieldEnum.DetailType] === 'List') {
        const modal = {
          SiteId: values[ReportFieldEnum.Site],
          studentIds: studentIds,
        };
        this.props.billingReportListAction(modal);
      }
    } else {
      createToast(
        toastType.error,
        'Error',
        'Please select at least one account',
        true
      );
    }
  };

  getBillingList = siteId => {
    this.props.getBillingAccountListAction(siteId);
  };

  getMainProps = () => {
    const { fetching, tableLoading, billingList } = this.props;

    return {
      toolbox: {
        formName: BILLING_ACCOUNT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: fetching,
          disabled: fetching || tableLoading || billingList.length === 0,
        },
        shown: true,
      },
    };
  };

  render() {
    const { formValues } = this.props;

    return (
      <Fragment>
        <Filter title={'Billing Account'} />
        <Main {...this.getMainProps()}>
          <BillingAccountForm
            billingList={this.props.billingList}
            checkAll={(a, b) => this.props.checkAll(a, b)}
            formValues={formValues}
            getBillingList={this.getBillingList}
            initialValues={{
              [ReportFieldEnum.DetailType]: 'List',
              [ReportFieldEnum.FromDate]: moment()
                .add(-1, 'days')
                .format('MM/DD/YYYY'),
              [ReportFieldEnum.ToDate]: moment().format('MM/DD/YYYY'),
            }}
            onSubmit={this.formSubmit}
            tableLoading={this.props.tableLoading && this.props.tableLoading}
            updateBillingData={data => this.props.updateBillingData(data)}
          />
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  const { BillingAccountState } = state;

  return {
    billingList: BillingAccountState.billingList,
    listReport: BillingAccountState.billingReportList,
    detailReport: BillingAccountState.billingReportDetails,
    tableLoading: BillingAccountState.tableLoading,
    fetching: BillingAccountState.reportLoading,
    formValues: getFormValues(BILLING_ACCOUNT_FORM_NAME)(state) || {},
  };
};

export const BillingAccount = withRouter(
  connect(
    mapStateToProps,
    actions
  )(BillingAccountContainer)
);



// WEBPACK FOOTER //
// ./src/pages/billingaccount/BillingAccount.js